<template>
  <div class="main-wrap">
    <main-header />
    
    <!-- Enhanced Service Hero -->
    <service-hero
      :title="service.title"
      :description="service.body"
      :image="service.img"
      :image-alt="$t('seo.mobile.title')"
      :badge="$t('header.services')"
      badge-icon="mdi-cellphone"
      :primary-button="{
        text: $t('apps.pricingOrder'),
        to: '/services/mobile#contact',
        icon: 'mdi-rocket-launch'
      }"
      :tech-stack="[
        { name: 'React Native', icon: 'mdi-react', color: 'cyan' },
        { name: 'iOS', icon: 'mdi-apple-ios', color: 'grey darken-2' },
        { name: 'Android', icon: 'mdi-android', color: 'green' }
      ]"
      :stats="[
        { value: '500+', label: $t('landing.projects') },
        { value: '98%', label: $t('landing.quality') },
        { value: '24/7', label: $t('landing.support') }
      ]"
      theme-variant="default"
    />

    <counter dark :data="data" />
    <v-container>
      <main-feature id="feature" class="ma-0 mt-16" :features="features" :title="$t('mobile.featureTitle')" />
      <!-- Enhanced Process Timeline Section -->
      <process-timeline :title="$t('mobile.processTitle')" :process-steps="years" />
    </v-container>

    <!-- Portfolio/Case Studies Section -->
    <showcase-apps
      v-if="portfolioApps && portfolioApps.length > 0"
      :title="$t('portfolio.showcaseTitle')"
      :subtitle="$t('portfolio.showcaseSubtitle')"
      badge="Portfolio"
      :apps="portfolioApps"
    />

    <div class="space-top-short" id="contact">
      <Contact :items="['تطبيقات الجوال']" :type="0" />
    </div>
    <div id="footer">
      <main-footer />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~/assets/pages";
</style>

<script>
import Header from "~/components/Header";
import { ServiceHero } from "~/components/hero";
import Counter from "~/components/Counter";
import Contact from "~/components/Forms/Contact";
import Footer from "~/components/Footer";
import MainFeature from "~/components/Feature/MainFeature";
import ProcessTimeline from "~/components/ProcessTimeline";
import ShowcaseApps from "~/components/Portfolio/ShowcaseApps";
import portfolioData from "~/data/portfolio.json";

export default {
  components: {
    "main-header": Header,
    "main-footer": Footer,
    ServiceHero,
    Counter,
    MainFeature,
    Contact,
    ProcessTimeline,
    ShowcaseApps
  },
  head() {
    const title = this.$t("seo.mobile.title");
    const desc = this.$t("seo.mobile.desc");
    return {
      title,
      meta: [
        { hid: "description", name: "description", content: desc },
        { hid: "og:title", property: "og:title", content: title },
        { hid: "og:description", property: "og:description", content: desc },
        { hid: "og:url", property: "og:url", content: `https://www.motanamy.com${this.$route.path}` },
        { hid: "twitter:title", name: "twitter:title", content: title },
        { hid: "twitter:description", name: "twitter:description", content: desc },
      ],
    };
  },
  computed: {
    service() {
      return this.$t("services")[1];
    },
    years() {
      return this.$t("mobile.process");
    },
    features() {
      return this.$t("mobile.features");
    },
    portfolioApps() {
      return portfolioData.filter(item => item.type === 'mobile');
    }
  },
  data: () => ({
    data: [
      {
        icon: "mdi-android",
        value: 3500
      },
      {
        icon: "mdi-apple-ios",
        value: 2400
      },
      {
        icon: "mdi-cordova",
        value: 150
      },
      {
        icon: "mdi-react",
        value: 7800
      }
    ]
  })
};
</script>
